import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/Home";
import DocumentViewerPage from "../pages/DocumentViewer";
import RecordInvoicePage from "../pages/RecordInvoice";
import { ErrorsPage } from "../modules/errors/ErrorsPage";

const AppRoute = () => {
  // Bootstrap token from URL (_t param) for LINE → external browser handoff
  // Must run before any child component mounts and calls the API
  const urlToken = new URLSearchParams(window.location.search).get('_t');
  if (urlToken) {
    localStorage.setItem('token', urlToken);
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="document-viewer" element={<DocumentViewerPage />} />
        <Route
          path="record-invoice"
          element={<RecordInvoicePage />}
        />
        {/* error */}
        <Route path="error/*" element={<ErrorsPage />} />

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;
